import React from 'react'
import Banner from "./banner"
import LoginForm from "./loginform"
import { Helmet } from 'react-helmet';

function index() {
  return (
    <>
      <Helmet>
        <title>Login to Your Account | Secure Access to Your Online Store</title>
        <meta name="description" content="Access your e-commerce dashboard securely. Manage your store, products, and orders with ease. Log in to start growing your business online today." />
      </Helmet>
      <div className='register'>
        <Banner />
        <LoginForm />
      </div>

    </>

  )
}

export default index